import {format, utcToZonedTime, zonedTimeToUtc} from 'date-fns-tz';

import {TIME_ZONE_ALMATY} from '../../../constants/date';

const getTeamLogo = id => `https://cdn.nur.kz/static/ti/${id}.png`;

const getPlayerHeight = () => {
  const width = window.innerWidth;

  if (width < 755) {
    return 170;
  }

  if (width < 1152) {
    return 366;
  }

  return 380;
};

const formatDateTime = date => {
  const utc = zonedTimeToUtc(date);

  return utcToZonedTime(utc, TIME_ZONE_ALMATY);
};

const getKzDateTime = (date, printFormat) => {
  if (date) {
    const formattedDate = formatDateTime(date);

    switch (printFormat) {
      case 'date':
        return format(formattedDate, 'dd.MM.yyyy', {timeZone: TIME_ZONE_ALMATY});
      case 'time':
        return format(formattedDate, 'HH:mm', {timeZone: TIME_ZONE_ALMATY});
      default:
        return '';
    }
  }

  return '';
};

const fetchData = ({domain = window.Site?.sportDomain, url}) => {
  if (!domain) {
    throw new Error('The International 2021: empty domain');
  }

  return fetch(`${domain}${url}`, {headers: {'Content-Type': 'application/json'}});
};

export {getTeamLogo, getPlayerHeight, getKzDateTime, fetchData};
